import { defineStore } from 'pinia'
import api from '@/utils/api'

export const useFranchiseStore = defineStore('franchise', {
  state: () => ({
    franchises: [],
    loading: false,
    error: null,
    lastFetched: null
  }),
  getters: {
    trendingFranchises: (state) => {
      return state.franchises.filter(f => f.trending_type === 'weekly') || []
    },
    monthlyFranchises: (state) => {
      return state.franchises.filter(f => f.trending_type === 'monthly' || f.trending_type === 'yearly') || []
    },
    needsRefresh: (state) => {
      // Refresh data if it's older than 5 minutes or if no data exists
      if (!state.lastFetched) return true
      const fiveMinutesAgo = Date.now() - (5 * 60 * 1000)
      return state.lastFetched < fiveMinutesAgo
    }
  },
  actions: {
    setFranchises(data) {
      this.franchises = data || []
      this.lastFetched = Date.now()
    },
    setLoading(loading) {
      this.loading = loading
    },
    setError(error) {
      this.error = error
    },
    async fetchFranchises(force = false) {
      // Don't fetch if already loading
      if (this.loading && !force) return
      
      // Don't fetch if data is fresh and not forcing
      if (!this.needsRefresh && !force && this.franchises.length > 0) return
      
      this.setLoading(true)
      this.setError(null)
      try {
        const data = await api.get('/franchises')
        this.setFranchises(data)
      } catch (error) {
        this.setError(error.message || 'Failed to fetch franchises')
        // Only clear data if we don't have any existing data
        if (this.franchises.length === 0) {
          this.franchises = []
        }
      } finally {
        this.setLoading(false)
      }
    }
  }
}) 